import React from 'react';

export function Logo({ className = "h-10 w-auto" }: { className?: string }) {
  return (
    <svg 
      viewBox="0 0 260 60" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Atende Turbo Logo"
    >
      <defs>
        <linearGradient id="blue-gradient" x1="0" y1="0" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#06b6d4" /> {/* cyan-500 */}
          <stop offset="100%" stopColor="#2563eb" /> {/* blue-600 */}
        </linearGradient>
      </defs>

      {/* --- TEXT GROUP --- */}
      <g transform="translate(0, 0)">
        <text 
          x="0" 
          y="42" 
          fontFamily="system-ui, -apple-system, sans-serif" 
          fontWeight="700" 
          fontSize="40" 
          fill="white"
          letterSpacing="-0.5"
        >
          Atende
        </text>
        
        <text 
          x="140" 
          y="42" 
          fontFamily="system-ui, -apple-system, sans-serif" 
          fontWeight="800" 
          fontSize="40" 
          fill="url(#blue-gradient)"
          fontStyle="italic"
          letterSpacing="-0.5"
        >
          Turbo
        </text>
      </g>
    </svg>
  );
}
